import React from 'react'
import {Box} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import {remCalc} from '../../../theme/_utils'
/**
 *
 * The original design had a box shadow but a bug was causing the box shadow to appear only after clicking on the page
 * so this container was created to simulate the dynamicaly active box shadow
 */

const CategoryFilterCardContainer = ({
    isActive = false,
    borderRadius = 'large-1',
    marginLeft = 0,
    marginRight = 0,
    children,
}) => {
    return (
        <Box
            position="relative"
            display="flex"
            marginLeft={marginLeft}
            marginRight={marginRight}
            overflow="visible"
            scrollbarWidth="none"
            msOverflowStyle="none"
            style={{
                '&::-webkit-scrollbar': {
                    display: 'none',
                },
            }}
        >
            {isActive && (
                <>
                    <Box
                        position="absolute"
                        inset="0"
                        border="small"
                        borderStyle="solid"
                        borderColor="var(--neutral-sm, rgba(19, 24, 58, 0.12))"
                        borderRadius={borderRadius}
                        transform={`translateY(${remCalc(1)})`}
                        pointerEvents="none"
                        zIndex={0}
                    />
                    <Box
                        position="absolute"
                        inset={remCalc(-2)}
                        border="large"
                        borderStyle="solid"
                        borderColor="var(--background-base-default, #EFEDEA)"
                        borderRadius={`calc(var(--chakra-radii-${borderRadius}) + ${remCalc(2)})`}
                        pointerEvents="none"
                        zIndex={0}
                    />
                    <Box
                        position="absolute"
                        inset="-0.35rem"
                        border="large"
                        borderStyle="solid"
                        borderColor="var(--border-neutral-focus, #6C7BA8)"
                        borderRadius="calc(var(--chakra-radii-large-1) + 0.25rem)"
                        pointerEvents="none"
                        zIndex={0}
                    />
                </>
            )}

            <Box position="relative" zIndex={1} w="100%">
                {children}
            </Box>
        </Box>
    )
}

CategoryFilterCardContainer.propTypes = {
    isActive: PropTypes.bool,
    borderRadius: PropTypes.string,
    marginLeft: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
    marginRight: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
    children: PropTypes.node,
}

export default CategoryFilterCardContainer
